import {useTranslation} from "@/i18n/hooks";
import {Dialog, DialogActions, DialogDescription, DialogTitle} from "@/components/tailwind/dialog";
import {Button} from "@/components/tailwind/button";

export interface SessionExpiredDialogProps {
    isOpen: boolean;
    onConfirm: () => void;
}

export default function SessionExpiredDialog({isOpen, onConfirm}: SessionExpiredDialogProps) {
    const {t} = useTranslation("errors");

    if (!isOpen) {
        return null;
    }

    return (
        <Dialog
            open={isOpen}
            onClose={noop}
            data-testid="session-expired-dialog"
        >
            <DialogTitle data-testid="session-expired-title">
                {t("session.expired.title")}
            </DialogTitle>
            <DialogDescription data-testid="session-expired-description">
                {t("session.expired.description")}
            </DialogDescription>
            <DialogActions>
                <Button
                    color="blue"
                    onClick={onConfirm}
                    data-testid="session-expired-confirm"
                    aria-label={t("session.expired.confirm")}
                >
                    {t("session.expired.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function noop() {
    // The session-expired dialog is intentionally non-dismissable: only the
    // confirm button moves the user forward.
}
